module.exports = __webpack_public_path__ + "static/media/3DPPA37.e721fc5e.jpg";